export enum TableAppearance {
    Default = 'default',
    Totals = 'totals',
    Cards = 'cards',
    Tall = 'tall',
    ExpandableRow = 'expandable-row'
}
